import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { FaxTypes } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FaxTypeOption } from 'src/app/pages/fax-register/models/fax-type-option.interface';
import { addSpacesToTypeName } from '../../../../pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { faxTypeOptionSelectors } from '../state/fax-type-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: FaxTypeSelectComponent,
        },
    ],
    selector: 'ndt-fax-type-select',
    templateUrl: './fax-type-select.component.html',
    standalone: false
})
export class FaxTypeSelectComponent extends LcsSingleSelectBase<FaxTypeOption> implements OnInit {
   @Input() excludedFaxTypes: FaxTypes[] = [];

   @Input() includedFaxTypes: FaxTypes[] | null;

   faxTypes$: Observable<FaxTypeOption[]>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.faxTypes$ = this.store.pipe(
         select(faxTypeOptionSelectors.selectFilteredItems),
         map((items: Array<FaxTypeOption>) => {
            let filteredItems = items;

            if (!this.includedFaxTypes && this.excludedFaxTypes && this.excludedFaxTypes.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return !this.excludedFaxTypes?.includes(item.typeName as FaxTypes);
               });
            }

            if (!this.excludedFaxTypes && this.includedFaxTypes && this.includedFaxTypes.length > 0) {
               filteredItems = filteredItems.filter((item) => {
                  return this.includedFaxTypes?.includes(item.typeName as FaxTypes);
               });
            }
            return filteredItems;
         })
      );
   }

   displayWith(item: FaxTypeOption | null): string | null {
      return item ? (item.typeName ? addSpacesToTypeName(item.typeName) : null) : null;
   }

   trackBy(item: FaxTypeOption | null) {
      return item ? item.typeName : null;
   }
}
